import CollectInfomation from "./CollectInfomation";
export default CollectInfomation;
